import { Link, NavLink, Outlet } from "react-router-dom";
import Logo from "../../components/Logo";
import { useAuth } from "../../contexts/AuthContext";
import { LogOut, LayoutDashboard, Users, Briefcase, CalendarDays, Newspaper, Image, Award, ClipboardList, Mail, Inbox, Ticket, Settings, Handshake, ScanLine, BarChart3, FileImage, Mic, ListChecks, Trophy, ShoppingBag, Package, Tag } from "lucide-react";

const LINKS = [
    { to: "/admin", end: true, label: "Overview", icon: LayoutDashboard, testid: "adm-overview" },
    { to: "/admin/players", label: "Players", icon: Users, testid: "adm-players" },
    { to: "/admin/coaches", label: "Coaches", icon: Briefcase, testid: "adm-coaches" },
    { to: "/admin/schedule", label: "Schedule", icon: CalendarDays, testid: "adm-schedule" },
    { to: "/admin/box-scores", label: "Box Scores", icon: BarChart3, testid: "adm-box-scores" },
    { to: "/admin/standings", label: "Standings", icon: Trophy, testid: "adm-standings" },
    { to: "/admin/news", label: "News", icon: Newspaper, testid: "adm-news" },
    { to: "/admin/gallery", label: "Gallery", icon: Image, testid: "adm-gallery" },
    { to: "/admin/press-assets", label: "Press Kit", icon: FileImage, testid: "adm-press-assets" },
    { to: "/admin/media-inquiries", label: "Media Inquiries", icon: Mic, testid: "adm-media-inquiries" },
    { to: "/admin/sponsors", label: "Sponsors", icon: Award, testid: "adm-sponsors" },
    { to: "/admin/sponsor-leads", label: "Sponsor Leads", icon: Handshake, testid: "adm-sponsor-leads" },
    { to: "/admin/tryouts", label: "Tryouts", icon: ClipboardList, testid: "adm-tryouts" },
    { to: "/admin/tickets/tiers", label: "Ticket Tiers", icon: Ticket, testid: "adm-ticket-tiers" },
    { to: "/admin/tickets/orders", label: "Ticket Orders", icon: Ticket, testid: "adm-ticket-orders" },
    { to: "/admin/products", label: "Store · Products", icon: ShoppingBag, testid: "adm-products" },
    { to: "/admin/store-orders", label: "Store · Orders", icon: Package, testid: "adm-store-orders" },
    { to: "/admin/discount-codes", label: "Discount Codes", icon: Tag, testid: "adm-discount-codes" },
    { to: "/admin/checkin", label: "Gate Check-in", icon: ScanLine, testid: "adm-checkin" },
    { to: "/admin/checkin/logs", label: "Check-in Logs", icon: ListChecks, testid: "adm-checkin-logs" },
    { to: "/admin/contact", label: "Messages", icon: Inbox, testid: "adm-contact" },
    { to: "/admin/press", label: "Press Inquiries", icon: Newspaper, testid: "adm-press" },
    { to: "/admin/newsletter", label: "Newsletter", icon: Mail, testid: "adm-newsletter" },
    { to: "/admin/settings", label: "Branding", icon: Settings, testid: "adm-settings" },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();
    return (
        <div className="min-h-screen bg-bg" data-testid="admin-layout">
            <aside className="fixed top-0 left-0 bottom-0 w-60 bg-bg-deep border-r border-line z-40 flex flex-col">
                <Link to="/" className="p-5 border-b border-line"><Logo size="sm" /></Link>
                <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
                    {LINKS.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.end}
                            data-testid={l.testid}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-3 py-2.5 text-xs tracking-widest uppercase font-bold transition-colors ${
                                    isActive ? "bg-purple-dark text-gold" : "text-ink hover:text-white hover:bg-bg-soft"
                                }`
                            }
                        >
                            <l.icon size={16} /> {l.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="p-4 border-t border-line">
                    <div className="text-[10px] uppercase tracking-widest text-ink">{user?.email}</div>
                    <button onClick={logout} data-testid="adm-logout" className="mt-3 text-xs flex items-center gap-2 text-ink hover:text-gold">
                        <LogOut size={14} /> Sign Out
                    </button>
                </div>
            </aside>
            <main className="ml-60 min-h-screen p-8 pb-24">
                <Outlet />
            </main>
        </div>
    );
}
